import { useContext } from "react";

import { UserContext } from "@/components/User";
import { usePageableQuery } from "@/core/queries";

import { fetchTimeReportVersions } from "../service";
import { TimeReportGuid } from "../types/TimeReport";

export const useTimeReportVersionsQuery = (timeReportGuid: TimeReportGuid) => {
  const { contextCompany, contextConsultantProfileId } = useContext(UserContext);

  const result = usePageableQuery([contextConsultantProfileId, "time-report-versions", timeReportGuid], params =>
    fetchTimeReportVersions({
      ...params,
      companyId: contextCompany?.id,
      timeReportGuid,
    }),
  );

  result.data.content.sort((a, b) => (a.version < b.version ? 1 : -1));

  return result;
};
